import { render, staticRenderFns } from "./ModalImportPasien.vue?vue&type=template&id=45e8f9c4&scoped=true"
import script from "./ModalImportPasien.vue?vue&type=script&lang=js"
export * from "./ModalImportPasien.vue?vue&type=script&lang=js"
import style0 from "./ModalImportPasien.vue?vue&type=style&index=0&id=45e8f9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e8f9c4",
  null
  
)

export default component.exports